import { Inject, Injectable } from '@angular/core';

import { BrandsEnum } from '@seb/web-design-system/core';

import { WC_CONFIG_PROVIDER, WcConfig } from '../models';
import { getBrandConfig } from '../web-common.config';

@Injectable({
  providedIn: 'root'
})
export class BrandCornerMapper {
  constructor(@Inject(WC_CONFIG_PROVIDER) protected wcConfig: WcConfig) {}

  toWcConfig(brand: BrandsEnum): WcConfig {
    return getBrandConfig(brand) ?? this.wcConfig;
  }
}
